import { LicenseManager } from 'ag-grid-enterprise';
import packageJson from 'package.json';

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import * as Sentry from '@sentry/angular';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

LicenseManager.setLicenseKey(
  'CompanyName=Neosperience S.p.A.,LicensedGroup=Neosperience,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-036986,SupportServicesEnd=18_January_2024_[v2]_MTcwNTUzNjAwMDAwMA==40aca2efd1936b1b05e7a40951e521bf'
);

if (environment.sentry.enabled) {
  Sentry.init({
    dsn: environment.sentry.dsn,
    environment: environment.env,
    integrations: [],
    release: packageJson.version,
    // Tracing
    // tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    // tracePropagationTargets: environment.sentry.tracePropagationTargets,
  });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => {
    setTimeout(() => {
      const loadingElement = document.getElementById('startup-loader');
      if (loadingElement) {
        loadingElement.remove();
      }
    }, 500);
  })
  .catch(err => console.error(err));
